<div style="height: 400px;" [hidden]="!isLoading">

  <div [hidden]="!isHasChart">
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-start" *ngIf="unit">
        <div class="d-flex block">
          <label for="" class="block-tite"> {{title}}</label>
          <span class="block-unit">Đơn vị: <em>{{unit}} đồng</em></span>
        </div>
      </div>
      <div class="line-chart" style="position: relative" [style.width]="width" [style.height]="height + 'px'" *ngIf="width">
        <canvas id="lineChart{{id}}" [style.width]="width"></canvas>
      </div>
      <div class="d-flex justify-content-end">
        <span class="block-unit">Ngày</span>
      </div>
    </div>
  </div>
  
  
  <div [hidden]="isHasChart" class="h-100">
    <div class="h-100 d-flex align-items-center justify-content-center mt-4">
      <img src="./assets/images/icons/nodata-chart.svg" width="200" height="200">
    </div>

  </div>
</div>
<div style="height: 400px;" [hidden]="isLoading" >
  <div class="h-100 d-flex align-items-center justify-content-center mt-4">
    <img src="./assets/images/icons/loading-background.svg" width="200" height="200">
  </div>
</div>
